import { render, staticRenderFns } from "./RecipientsStep.vue?vue&type=template&id=48fc23b1&scoped=true&"
import script from "./RecipientsStep.vue?vue&type=script&setup=true&lang=js&"
export * from "./RecipientsStep.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./RecipientsStep.vue?vue&type=style&index=0&id=48fc23b1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48fc23b1",
  null
  
)

export default component.exports